"use client";

import { useEffect, useRef, useState } from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoiceWidget() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  const cardRef = useRef<HTMLDivElement>(null);
  const [borderOpacity, setBorderOpacity] = useState(0.4);
  useEffect(() => {
    const card = cardRef.current;
    if (!card) return;
    const handleMouseMove = (e: MouseEvent) => {
      const rect = card.getBoundingClientRect();
      const distX = Math.max(rect.left - e.clientX, 0, e.clientX - rect.right);
      const distY = Math.max(rect.top - e.clientY, 0, e.clientY - rect.bottom);
      const dist = Math.sqrt(distX * distX + distY * distY);
      const maxDist = 300;
      const proximity = Math.max(0, 1 - dist / maxDist);
      setBorderOpacity(0.4 + proximity * 0.6);
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section id="voice-widget" ref={sectionRef} className="relative w-full overflow-hidden bg-background" style={{
    padding: "140px 0"
  }}>
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612503/img/neural_network_glow_dark.png)] bg-cover bg-center opacity-20" />

      {}
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(211, 53%, 8%, 0.85) 0%, hsla(211, 53%, 4%, 0.97) 100%)"
    }} />

      {}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full pointer-events-none" style={{
      background: "radial-gradient(circle, hsla(195, 89%, 59%, 0.07) 0%, transparent 70%)",
      filter: "blur(60px)"
    }} />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full pointer-events-none" style={{
      background: "radial-gradient(circle, hsla(195, 89%, 59%, 0.05) 0%, transparent 70%)",
      filter: "blur(50px)"
    }} />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-5" style={{
      backgroundImage: "linear-gradient(hsla(195, 89%, 59%, 0.5) 1px, transparent 1px), linear-gradient(90deg, hsla(195, 89%, 59%, 0.5) 1px, transparent 1px)",
      backgroundSize: "60px 60px"
    }} />

      {}
      <div className="relative z-10 flex items-center justify-center px-4">
        <div ref={cardRef} className="w-full max-w-3xl" style={{
        transition: "all 0.3s ease"
      }}>
          {}
          <div className={`relative rounded-xl backdrop-blur-xl transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          background: "hsla(211, 53%, 15%, 0.45)",
          border: `1px solid hsla(195, 89%, 59%, ${borderOpacity})`,
          boxShadow: `0 0 40px hsla(195, 89%, 59%, ${borderOpacity * 0.3}), 0 8px 32px hsla(211, 53%, 4%, 0.6), inset 0 1px 0 hsla(195, 89%, 80%, 0.1)`,
          transition: "border-color 0.2s ease, box-shadow 0.2s ease, opacity 0.7s ease, transform 0.7s ease"
        }}>
            {}
            <div className="absolute top-0 left-0 w-6 h-6 pointer-events-none" style={{
            borderTop: `2px solid var(--primary)`,
            borderLeft: `2px solid var(--primary)`,
            borderRadius: "var(--radius) 0 0 0"
          }} />
            <div className="absolute top-0 right-0 w-6 h-6 pointer-events-none" style={{
            borderTop: `2px solid var(--primary)`,
            borderRight: `2px solid var(--primary)`,
            borderRadius: "0 var(--radius) 0 0"
          }} />
            <div className="absolute bottom-0 left-0 w-6 h-6 pointer-events-none" style={{
            borderBottom: `2px solid var(--primary)`,
            borderLeft: `2px solid var(--primary)`,
            borderRadius: "0 0 0 var(--radius)"
          }} />
            <div className="absolute bottom-0 right-0 w-6 h-6 pointer-events-none" style={{
            borderBottom: `2px solid var(--primary)`,
            borderRight: `2px solid var(--primary)`,
            borderRadius: "0 0 var(--radius) 0"
          }} />

            <div className="p-10 md:p-16 flex flex-col items-center gap-10">
              <iframe id="audio_iframe" src="https://widget.us.synthflow.ai/widget/v2/9f854026-4f72-494c-88bf-1d31a6e24e17/1775052636355x456958447609375300" allow="microphone; autoplay" width="400" height="550" scrolling="no" style={{
              display: "block",
              background: "transparent",
              border: "none",
              zIndex: 999,
              pointerEvents: "auto"
            }} />
            </div>
          </div>
        </div>
      </div>

      {}
      <style>{`
        @keyframes aiPulse {
          0% {
            transform: scale(0.85);
            opacity: 0.8;
          }
          60% {
            transform: scale(1.15);
            opacity: 0;
          }
          100% {
            transform: scale(1.15);
            opacity: 0;
          }
        }

        @keyframes coreBreath {
          0%, 100% {
            box-shadow: 0 0 20px hsla(195, 89%, 59%, 0.8), 0 0 40px hsla(195, 89%, 59%, 0.4);
            transform: scale(1);
          }
          50% {
            box-shadow: 0 0 30px hsla(195, 89%, 59%, 1), 0 0 60px hsla(195, 89%, 59%, 0.6);
            transform: scale(1.08);
          }
        }

        @keyframes statusBlink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </section>;
}